var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'wgt-member-info': true,
}},[_c('el-image',{staticClass:"cover-bg",attrs:{"src":_vm.value.backgroundImg,"mode":"aspectFill"}}),_c('div',{staticClass:"wgt-bd",style:(_vm.contentStyle)},[_c('el-image',{staticClass:"avatar",attrs:{"src":"http://prd-aarminp-image.oss-cn-beijing.aliyuncs.com/xcximage/member/avatar_default.png"}}),_c('div',{staticClass:"name"},[_vm._v("HOYY")]),_c('div',{staticClass:"no"},[_vm._v("NO.88888888")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }